//@flow
import React from 'react';
import { themr } from 'react-css-themr';
import moment from 'moment-timezone';
import classnames from 'classnames';
import { Checkbox, CheckboxTypes } from 'common/components/core/checkbox';
import ReactHoverObserver from 'react-hover-observer';

import DefaultSingleSlotSelector from 'common/entity/components/slot/SingleSlotSelector';
import { Button } from 'common/components/core/button';
import theme from './TimeSlots.scss';
import { dashboardColors } from 'common/enums/ColorEnum';
import { DateInputFormats } from 'common/utils/DateTimeUtils';

const timeSlotsFactory = ({
    SingleSlotSelector = DefaultSingleSlotSelector
}) => {
    class TimeSlots extends React.PureComponent {
        render() {
            const {
                selectedDays,
                theme,
                t,
                onDelete,
                onChange,
                onCopyToAllClick,
                onAddSlotClick,
                onToggleDaySelection,
                slots,
                dayOfWeek,
                ...others
            } = this.props;
            const isEnabled = selectedDays.indexOf(dayOfWeek) >= 0;

            const slotSelectors = slots.map((slot, index) => {
                const start = moment(slot.start, DateInputFormats.HOUR24_SHORT);
                const end = moment(slot.end, DateInputFormats.HOUR24_SHORT);

                let isInvalid = false;
                if (index > 0) {
                    isInvalid = slot.isTimeSlotOverlapping(slots, index);
                }

                return (
                    <SingleSlotSelector
                        {...others}
                        key={index}
                        theme={theme}
                        t={t}
                        start={start}
                        end={end}
                        slotFor={dayOfWeek}
                        index={index}
                        onChange={onChange}
                        onDelete={onDelete}
                        error={
                            isInvalid
                                ? t('validations:timeSlot.overlappingSlots')
                                : null
                        }
                        disabled={!isEnabled}
                    />
                );
            });

            const addSlotButton = onAddSlotClick ? (
                <Button
                    className={theme.addSlotButton}
                    semibold
                    theme={theme}
                    onClick={onAddSlotClick}
                    fieldId={dayOfWeek}
                    ripple={false}
                    label={`+ ${t('slotSelector.addSlot')}`}
                />
            ) : null;

            const copyToAll = (
                <Button
                    semibold
                    theme={theme}
                    icon="duplicate"
                    label={t('slotSelector.copyToAll')}
                    className={theme.copyToAllButton}
                    ripple={false}
                    onClick={onCopyToAllClick}
                    fieldId={dayOfWeek}
                />
            );

            const actionButtons = (
                <div className={theme.slotActionButtonsWrap}>
                    {addSlotButton}
                    {slots.size ? copyToAll : null}
                </div>
            );
            return (
                <ReactHoverObserver>
                    {({ isHovering }) => (
                        <div
                            className={classnames(
                                theme.horizontal,
                                theme.slotsForDay,
                                {
                                    [theme.hovered]: isHovering
                                }
                            )}
                        >
                            <Checkbox
                                className={classnames(theme.checkbox)}
                                theme={theme}
                                smallCheckbox
                                checkboxType={CheckboxTypes.Solid}
                                checked={isEnabled}
                                label={t(`days.${dayOfWeek}`)}
                                onChange={onToggleDaySelection}
                                id={dayOfWeek}
                                checkboxColor={dashboardColors.darkSkyBlue.name}
                            />
                            <div className={theme.vertical}>
                                {slotSelectors}
                                {isHovering && isEnabled ? actionButtons : null}
                            </div>
                        </div>
                    )}
                </ReactHoverObserver>
            );
        }
    }
    return themr(TimeSlots, theme)(TimeSlots);
};

const TimeSlots = timeSlotsFactory({});
export default TimeSlots;
export { TimeSlots, timeSlotsFactory };
